import { render, staticRenderFns } from "./MoveVehicleBetweenOrg.vue?vue&type=template&id=a5569654&scoped=true"
import script from "./MoveVehicleBetweenOrg.vue?vue&type=script&lang=js"
export * from "./MoveVehicleBetweenOrg.vue?vue&type=script&lang=js"
import style0 from "./MoveVehicleBetweenOrg.vue?vue&type=style&index=0&id=a5569654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5569654",
  null
  
)

export default component.exports